"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/ja-JP.ts
var ja_JP_exports = {};
__export(ja_JP_exports, {
  AG_CHARTS_LOCALE_JA_JP: () => AG_CHARTS_LOCALE_JA_JP
});
module.exports = __toCommonJS(ja_JP_exports);
var AG_CHARTS_LOCALE_JA_JP = {
  ariaAnnounceChart: "\u30C1\u30E3\u30FC\u30C8, ${seriesCount}[number]\u30B7\u30EA\u30FC\u30BA",
  ariaAnnounceFlowProportionLink: "\u30EA\u30F3\u30AF ${index} / ${count}\u3001${from} \u304B\u3089 ${to} \u3078\u3001${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u30CE\u30FC\u30C9 ${index} / ${count}\u3001${description}",
  ariaAnnounceGaugeChart: "\u30B2\u30FC\u30B8\u30C1\u30E3\u30FC\u30C8\u3001${caption}",
  ariaAnnounceHierarchyChart: "\u968E\u5C64\u30C1\u30E3\u30FC\u30C8, ${caption}",
  ariaAnnounceHierarchyDatum: "\u30EC\u30D9\u30EB ${level}[number]\u3001${count}[number] \u306E\u5B50\u4F9B\u3001${description}",
  ariaAnnounceHoverDatum: "${datum}\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u3066\u3044\u307E\u3059",
  ariaDescriptionLegendItem: "Space \u30AD\u30FC\u307E\u305F\u306F Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u8868\u793A\u3092\u5207\u308A\u66FF\u3048\u307E\u3059",
  ariaLabelAddHorizontalLine: "\u6C34\u5E73\u7DDA\u3092\u8FFD\u52A0",
  ariaLabelAnnotationOptionsToolbar: "\u6CE8\u91C8\u30AA\u30D7\u30B7\u30E7\u30F3",
  ariaLabelAnnotationSettingsDialog: "\u6CE8\u91C8\u8A2D\u5B9A",
  ariaLabelColorPicker: "\u30AB\u30E9\u30FC\u30D4\u30C3\u30AB\u30FC",
  ariaLabelFinancialCharts: "\u30D5\u30A1\u30A4\u30CA\u30F3\u30B7\u30E3\u30EB\u30C1\u30E3\u30FC\u30C8",
  ariaLabelLegend: "\u51E1\u4F8B",
  ariaLabelLegendItem: "${label}, \u51E1\u4F8B\u30A2\u30A4\u30C6\u30E0 ${index}[number] / ${count}[number]",
  ariaLabelLegendItemUnknown: "\u4E0D\u660E\u306A\u51E1\u4F8B\u9805\u76EE",
  ariaLabelLegendPageNext: "\u6B21\u306E\u51E1\u4F8B\u30DA\u30FC\u30B8",
  ariaLabelLegendPagePrevious: "\u524D\u306E\u51E1\u4F8B\u30DA\u30FC\u30B8",
  ariaLabelLegendPagination: "\u51E1\u4F8B\u30DA\u30FC\u30B8\u30CD\u30FC\u30B7\u30E7\u30F3",
  ariaLabelNavigator: "\u30CA\u30D3\u30B2\u30FC\u30BF\u30FC",
  ariaLabelNavigatorMaximum: "\u6700\u5927",
  ariaLabelNavigatorMinimum: "\u6700\u5C0F",
  ariaLabelNavigatorRange: "\u7BC4\u56F2",
  ariaLabelRangesToolbar: "\u7BC4\u56F2",
  ariaLabelSettingsTabBar: "\u8A2D\u5B9A",
  ariaLabelZoomToolbar: "\u30BA\u30FC\u30E0",
  ariaValuePanRange: "${min}[percent0to2dp] \u304B\u3089 ${max}[percent0to2dp]",
  contextMenuDownload: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
  contextMenuPanToCursor: "\u3053\u3053\u306B\u30D1\u30F3\u3059\u308B",
  contextMenuToggleOtherSeries: "\u4ED6\u306E\u30B7\u30EA\u30FC\u30BA\u3092\u5207\u308A\u66FF\u3048\u308B",
  contextMenuToggleSeriesVisibility: "\u8868\u793A\u3092\u5207\u308A\u66FF\u3048\u308B",
  contextMenuZoomToCursor: "\u3053\u3053\u306B\u30BA\u30FC\u30E0",
  dialogHeaderChannel: "\u30C1\u30E3\u30F3\u30CD\u30EB",
  dialogHeaderDatePriceRange: "\u65E5\u4ED8\u3068\u4FA1\u683C",
  dialogHeaderDateRange: "\u65E5\u4ED8\u7BC4\u56F2",
  dialogHeaderFibonacciRange: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1\u30EA\u30C8\u30EC\u30FC\u30B9\u30E1\u30F3\u30C8",
  dialogHeaderLine: "\u30E9\u30A4\u30F3",
  dialogHeaderPriceRange: "\u4FA1\u683C\u7BC4\u56F2",
  dialogHeaderText: "\u30C6\u30AD\u30B9\u30C8",
  dialogInputAlign: "\u6574\u5217",
  dialogInputColorPicker: "\u8272",
  dialogInputColorPickerAltText: "\u30C6\u30AD\u30B9\u30C8\u306E\u8272",
  dialogInputExtendAbove: "\u4E0A\u306B\u62E1\u5F35\u3059\u308B",
  dialogInputExtendBelow: "\u4EE5\u4E0B\u306B\u62E1\u5F35",
  dialogInputExtendChannelEnd: "\u30C1\u30E3\u30CD\u30EB\u306E\u7D42\u308F\u308A\u3092\u62E1\u5F35\u3059\u308B",
  dialogInputExtendChannelStart: "\u30C1\u30E3\u30CD\u30EB\u306E\u958B\u59CB\u3092\u5EF6\u9577\u3059\u308B",
  dialogInputExtendLeft: "\u300C\u5DE6\u306B\u4F38\u3070\u3059\u300D",
  dialogInputExtendLineEnd: "\u30E9\u30A4\u30F3\u7D42\u7AEF\u3092\u62E1\u5F35\u3059\u308B",
  dialogInputExtendLineStart: "\u7DDA\u306E\u958B\u59CB\u3092\u5EF6\u9577\u3059\u308B",
  dialogInputExtendRight: "\u53F3\u3078\u62E1\u5F35",
  dialogInputFibonacciBands: "\u30D0\u30F3\u30C9",
  dialogInputFibonacciBandsAltText: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1\u30D0\u30F3\u30C9",
  dialogInputFillColorPicker: "\u5857\u308A\u3064\u3076\u3057",
  dialogInputFillColorPickerAltText: "\u5857\u308A\u3064\u3076\u3057\u306E\u8272",
  dialogInputFontSize: "\u30B5\u30A4\u30BA",
  dialogInputFontSizeAltText: "\u30D5\u30A9\u30F3\u30C8\u30B5\u30A4\u30BA",
  dialogInputLineStyle: "\u30C0\u30C3\u30B7\u30E5",
  dialogInputPosition: "\u4F4D\u7F6E",
  dialogInputReverse: "\u53CD\u8EE2",
  dialogInputShowFill: "\u5857\u308A\u3064\u3076\u3057\u3092\u8868\u793A",
  dialogInputStrokeWidth: "\u592A\u3055",
  dialogInputStrokeWidthAltText: "\u7DDA\u306E\u592A\u3055",
  iconAltTextAlignCenter: "\u4E2D\u592E\u63C3\u3048",
  iconAltTextAlignLeft: "\u5DE6",
  iconAltTextAlignRight: "\u53F3",
  iconAltTextClose: "\u9589\u3058\u308B",
  iconAltTextLineStyleDashed: "\u9577\u3044\u7834\u7DDA",
  iconAltTextLineStyleDotted: "\u77ED\u3044\u7834\u7DDA",
  iconAltTextLineStyleSolid: "\u5B9F\u7DDA",
  iconAltTextPositionBottom: "\u4E0B",
  iconAltTextPositionCenter: "\u4E2D\u592E",
  iconAltTextPositionTop: "\u300C\u30C8\u30C3\u30D7\u300D",
  inputTextareaPlaceholder: "\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0",
  measurerDateRangeBars: "${value}[number] \u672C\u306E\u30D0\u30FC",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "\u300E${value}[number]\u300F",
  measurerVolume: "\u30DC\u30EA\u30E5\u30FC\u30E0 ${value}",
  overlayLoadingData: "\u30C7\u30FC\u30BF\u3092\u8AAD\u307F\u8FBC\u307F\u4E2D...",
  overlayNoData: "\u8868\u793A\u3059\u308B\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
  overlayNoVisibleSeries: "\u8868\u793A\u53EF\u80FD\u306A\u30B7\u30EA\u30FC\u30BA\u304C\u3042\u308A\u307E\u305B\u3093",
  overlayUnsupportedBrowser: "\u4E92\u63DB\u6027\u306E\u306A\u3044\u30D6\u30E9\u30A6\u30B6\u30FC\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u3067\u3059\u3002\u30D6\u30E9\u30A6\u30B6\u30FC\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  seriesHistogramTooltipCount: "${yName} (\u30AB\u30A6\u30F3\u30C8)",
  seriesHistogramTooltipFrequency: "\u983B\u5EA6",
  seriesHistogramTooltipMean: "${yName} (\u5E73\u5747)",
  seriesHistogramTooltipSum: "${yName} (\u5408\u8A08)",
  toolbarAnnotationsArrow: "\u77E2\u5370",
  toolbarAnnotationsArrowDown: "\u4E0B\u5411\u304D\u306E\u77E2\u5370",
  toolbarAnnotationsArrowUp: "\u77E2\u5370\u4E0A",
  toolbarAnnotationsCallout: "\u56F3\u5F62\u6CE8\u91C8",
  toolbarAnnotationsClearAll: "\u3059\u3079\u3066\u30AF\u30EA\u30A2",
  toolbarAnnotationsComment: "\u30B3\u30E1\u30F3\u30C8",
  toolbarAnnotationsDatePriceRange: "\u300C\u65E5\u4ED8\u3068\u4FA1\u683C\u300D",
  toolbarAnnotationsDateRange: "\u65E5\u4ED8\u7BC4\u56F2",
  toolbarAnnotationsDelete: "\u524A\u9664",
  toolbarAnnotationsDisjointChannel: "\u975E\u9023\u7D50\u30C1\u30E3\u30CD\u30EB",
  toolbarAnnotationsDragHandle: "\u30C4\u30FC\u30EB\u30D0\u30FC\u3092\u30C9\u30E9\u30C3\u30B0",
  toolbarAnnotationsFibonacciAnnotations: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1",
  toolbarAnnotationsFibonacciRetracement: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1\u30FB\u30EA\u30C8\u30EC\u30FC\u30B9\u30E1\u30F3\u30C8",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1\u30C8\u30EC\u30F3\u30C9\u30D9\u30FC\u30B9",
  toolbarAnnotationsFillColor: "\u5857\u308A\u3064\u3076\u3057\u306E\u8272",
  toolbarAnnotationsHorizontalLine: "\u6C34\u5E73\u7DDA",
  toolbarAnnotationsLineAnnotations: "\u30C8\u30EC\u30F3\u30C9\u30E9\u30A4\u30F3",
  toolbarAnnotationsLineColor: "\u7DDA\u306E\u8272",
  toolbarAnnotationsLineStrokeWidth: "\u7DDA\u306E\u592A\u3055",
  toolbarAnnotationsLineStyle: "\u7DDA\u30B9\u30BF\u30A4\u30EB",
  toolbarAnnotationsLock: "\u30ED\u30C3\u30AF",
  toolbarAnnotationsMeasurerAnnotations: "\u6E2C\u5B9A\u30C4\u30FC\u30EB",
  toolbarAnnotationsNote: "\u30CE\u30FC\u30C8",
  toolbarAnnotationsParallelChannel: "\u30D1\u30E9\u30EC\u30EB\u30C1\u30E3\u30CD\u30EB",
  toolbarAnnotationsPriceRange: "\u4FA1\u683C\u7BC4\u56F2",
  toolbarAnnotationsQuickDatePriceRange: "\u6E2C\u5B9A",
  toolbarAnnotationsSettings: "\u8A2D\u5B9A",
  toolbarAnnotationsShapeAnnotations: "\u77E2\u5370",
  toolbarAnnotationsText: "\u30C6\u30AD\u30B9\u30C8",
  toolbarAnnotationsTextAnnotations: "\u30C6\u30AD\u30B9\u30C8\u6CE8\u91C8",
  toolbarAnnotationsTextColor: "\u30C6\u30AD\u30B9\u30C8\u306E\u8272",
  toolbarAnnotationsTextSize: "\u6587\u5B57\u30B5\u30A4\u30BA",
  toolbarAnnotationsTrendLine: "\u30C8\u30EC\u30F3\u30C9\u30E9\u30A4\u30F3",
  toolbarAnnotationsUnlock: "\u30ED\u30C3\u30AF\u89E3\u9664",
  toolbarAnnotationsVerticalLine: "\u5782\u76F4\u7DDA",
  toolbarRange1Month: "1\u30F6\u6708",
  toolbarRange1MonthAria: "1\u304B\u6708",
  toolbarRange1Year: "1\u5E74",
  toolbarRange1YearAria: "1\u5E74",
  toolbarRange3Months: "3\u30F6\u6708",
  toolbarRange3MonthsAria: "3\u30F6\u6708",
  toolbarRange6Months: "6\u30F6\u6708",
  toolbarRange6MonthsAria: "6\u304B\u6708",
  toolbarRangeAll: "\u3059\u3079\u3066",
  toolbarRangeAllAria: "\u3059\u3079\u3066",
  toolbarRangeYearToDate: "\u5E74\u521D\u6765",
  toolbarRangeYearToDateAria: "\u5E74\u521D\u6765",
  toolbarSeriesTypeCandles: "\u30AD\u30E3\u30F3\u30C9\u30EB",
  toolbarSeriesTypeDropdown: "\u30B0\u30E9\u30D5\u30BF\u30A4\u30D7",
  toolbarSeriesTypeHighLow: "\u9AD8\u4F4E",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u7A7A\u6D1E\u306E\u308D\u3046\u305D\u304F",
  toolbarSeriesTypeLine: "\u30E9\u30A4\u30F3",
  toolbarSeriesTypeLineWithMarkers: "\u30DE\u30FC\u30AB\u30FC\u4ED8\u304D\u6298\u308C\u7DDA\u30B0\u30E9\u30D5",
  toolbarSeriesTypeOHLC: "OHLC(\u59CB\u5024\u3001\u9AD8\u5024\u3001\u5B89\u5024\u3001\u7D42\u5024)",
  toolbarSeriesTypeStepLine: "\u968E\u6BB5\u7DDA",
  toolbarZoomPanEnd: "\u6700\u5F8C\u307E\u3067\u30D1\u30F3",
  toolbarZoomPanLeft: "\u5DE6\u306B\u30D1\u30F3",
  toolbarZoomPanRight: "\u53F3\u306B\u30D1\u30F3",
  toolbarZoomPanStart: "\u6700\u521D\u306B\u30D1\u30F3\u3059\u308B",
  toolbarZoomReset: "\u30BA\u30FC\u30E0\u3092\u30EA\u30BB\u30C3\u30C8",
  toolbarZoomZoomIn: "\u30BA\u30FC\u30E0\u30A4\u30F3",
  toolbarZoomZoomOut: "\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8",
  tooltipPaginationStatus: "${index}[number] \u306E ${count}[number]"
};
//# sourceMappingURL=ja-JP.cjs.js.map
